export default "__VITE_ASSET__BMFONj5d__"